import { Injectable } from "@angular/core";
import { ClientSelectionService } from "../components/clients/client-selection.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { TPA_RRE, GetTPA_RREResponse } from "../models/tpa-rre-management.model";

@Injectable({
    providedIn: "root",
})
export class TpaRreManagementService {
    private readonly endpoint = "tpa-rre-management/tpas";

    constructor(
        private http: HttpClient,
        private clientSelectionService: ClientSelectionService
    ) {}

    getTPA_RREs(sortBy?: string, sortDir?: 'asc' | 'desc', searchTerm?: string, skip = 0, count = 20): Observable<GetTPA_RREResponse> {
        let params = new HttpParams()
            .set('skip', skip.toString())
            .set('count', count.toString())
            .set('sortBy', sortBy ?? '')
            .set('sortDir', sortDir ?? '');

        const trimmedSearchTerm = String(searchTerm ?? '').trim();
        if (trimmedSearchTerm) {
            params = params.set('search', trimmedSearchTerm);
        }

        const url = `${environment.apiUrl}${this.endpoint}`;
        return this.http.get<GetTPA_RREResponse>(url, {headers: this.getHeaders(), params});
    }

    addTPA_RRE(tpaRre: TPA_RRE): Observable<{ success: boolean }>{
        const url = `${environment.apiUrl}${this.endpoint}`;
        return this.http.post<{success: boolean}>(url, tpaRre, {headers: this.getHeaders()});
    }

    updateTPA_RRE(tpaRre: TPA_RRE): Observable<{ success: boolean }>{
        const url = `${environment.apiUrl}${this.endpoint}`;
        return this.http.put<{success: boolean}>(url, tpaRre, {headers: this.getHeaders()});
    }

    private getHeaders() {
        const clientDBName = this.clientSelectionService.getSelectedClientDbName();
        return new HttpHeaders({
            ClientDBName: clientDBName,
        });
    }
}